(function($) {
	
	var $stack = $('#stack');
	if ( $stack.length == 0 ) {
		return;
	}

	var $floorLinks = $('#stack .floors > ul > li');
	var $floorHighlights = $('#stack .floor-images .images');
	var $floorPlans = $('#stack .floor-plans');

	var displayFloorPlan = function( floor ) {
		var $floorPlan = $floorPlans.find('[data-floor="'+floor+'"]');
		$floorPlans.find('figure').hide();
		$floorPlan.show();
		var $floorImage = $floorHighlights.find('[data-floor="'+floor+'"]');
		$floorImage.addClass('floor-plan-active');
		$stack.addClass('floor-plan-active');
        scrollToTop();
	}

	$stack.find('.back').on('click', function(event) {
		event.preventDefault();

		$floorHighlights.find('figure').removeClass('floor-plan-active');
		$stack.removeClass('floor-plan-active');
        scrollToTop();
	});

	$floorLinks.hover(function() {
		var floor = $(this).data('floor');
		var $floorImage = $floorHighlights.find('[data-floor="'+floor+'"]');
		$floorImage.fadeIn(100);
	}, function() {
		var floor = $(this).data('floor');
		var $floorImage = $floorHighlights.find('[data-floor="'+floor+'"]');
		$floorImage.fadeOut(100);
	});

	$floorLinks.on('click', function(event) {
		event.preventDefault();
		const $floorLink = $(this);
		if($floorLink.is('[data-has-floor-image]')){
            let floor = $floorLink.data('floor');
            displayFloorPlan( floor );
		}

	});


	function scrollToTop(){

        $('html, body').animate({
            scrollTop: 0
        }, 500);
	}

})(jQuery);